import { useState } from "react";
import { KTIcon } from "../../../../_metronic/helpers";

const OrgHeader = ({ search, setSearch, setStatus, status }) => {

  return (
    <div className="card-header border-0 pt-6 align-items-center flex-nowrap">
      <div className="d-flex bg-light rounded">
        <span className={`d-flex align-items-center px-6 py-3 fw-bold cursor-pointer rounded bg-${status == 'active' ? 'success text-white' : 'light text-dark'}`}
          onClick={() => setStatus('active')}>Active</span>
        <span className={`d-flex align-items-center px-4 py-2 fw-bold cursor-pointer rounded bg-${status == 'pending' ? 'success text-white' : 'light text-dark'}`}
          onClick={() => setStatus('pending')}>Pending</span>
        <span className={`d-flex align-items-center px-4 py-2 fw-bold cursor-pointer rounded bg-${status == 'deleted' ? 'success text-white' : 'light text-dark'}`}
          onClick={() => setStatus('deleted')}>Deleted</span>
      </div>
      <div className='d-flex'>
        <div className="d-flex align-items-center position-relative">
          <KTIcon
            iconName="magnifier"
            className="fs-1 position-absolute ms-6"
          />
          <input
            type="text"
            data-kt-user-table-filter="search"
            className="form-control form-control-solid w-300px ps-14"
            placeholder={`Search By Organization Name`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export { OrgHeader };
